import { UPDATE_PASSWORD } from '../types'

const INITIAL_STATE = {
  updatePassword: [],
  userProfile: [],
}
const updatePassword = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_PASSWORD:
      return {
        ...state,
        updatePassword: payload.data,
        loader: false,
      }

    default:
      return state
  }
}
export default updatePassword
